import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../components/layout/Layout";
import Home from "../components/dashboard/home/Home";
import AudioTour from "../components/dashboard/audioTour/index";
import Restaurent from "../components/dashboard/restaurents/index";
import ThingsToDo from "../components/dashboard/thingsToDo/ThingsTODOIndex";
import FilterPopularThings from "../components/dashboard/thingsToDo/FilterPopularThings";
import ErrorPage from "../components/ErrorPage";
import CarRental from "../components/dashboard/carRental/CarRentalIndex";
import Flight from "../components/dashboard/flight/FlightIndex";
import Hotels from "../components/dashboard/hotel/HotelIndex";
import { useEffect } from "react";
import Sports from "../components/dashboard/sports/SportIndex";
import Deals from "../components/dashboard/deals/DealIndex";
import NewDeals from "../components/dashboard/deals/DealSlugIndex";
import SingleBlog from "../components/dashboard/blog/SingleBlogDemo";
import BlogMain from "../components/dashboard/blog/index";
import { useDispatch, useSelector } from "react-redux";
import { setPlace } from "../Redux/Action/Action";
import AOS from "aos";
import "aos/dist/aos.css";
import LeadPage from "../components/dashboard/demoLeadingPage/index";
import ValidateRouteByCity from "../components/dashboard/validateCity/ValidateCityRoute";
import MainTravelPreferences from "../components/dashboard/travelPreferences";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ThingsToDoRouteDecider from "../components/dashboard/thingsToDo/ThingsToDoRouteDecider";

const CreateRoutes = () => {
  const place = useSelector(state => state.place)
  const location = useLocation();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const selectedCity = localStorage.getItem("selectedCity");
    // 🚫 ABSOLUTE STOP: never auto-select city for things-to-do
    if (location.pathname.startsWith("/things-to-do")) {
      return;
    }
    if (!selectedCity) return;

    const path = location.pathname;

    // Do not auto-redirect for these base routes
    const ignoreRoutes = ["/", "/single-blog"
      , "/deals/flights",
      "/deals/hotels",
      "/deals/vacations",
      "/deals/tours",
      "/deals/cruises",
      "/deals/adventures",
    ];

    if (
      ignoreRoutes.some((route) => path === route || path.startsWith(route + "/"))
    ) {
      return;
    }

    const segments = path.split("/").filter(Boolean);

    // Example paths:
    // /restaurant → ["restaurant"]
    // /restaurant/newyork → ["restaurant","newyork"]

    if (segments.length === 1) {
      // no city → add selectedCity
      navigate(`/${segments[0]}/${selectedCity}`, { replace: true });
    }

    if (segments[0] === "things-to-do") {
      return;
    }

    if (segments.length >= 2) {
      const currentCity = segments[1];

      // if city param ≠ selectedCity → replace it
      if (currentCity.toLowerCase() !== selectedCity.toLowerCase()) {
        segments[1] = selectedCity;
        navigate("/" + segments.join("/"), { replace: true });
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    // ❌ Never set place for blog or single-blog
    if (
      location.pathname.includes("/blog") ||
      location.pathname.startsWith("/single-blog")
    ) {
      dispatch(setPlace(place));
      return;
    }

    let count = 0;
    for (let i = 0; i < location.pathname.length; i++) {
      if (location.pathname[i] === "/") count++;
    }

    if (count < 1) {
      dispatch(setPlace(""));
    }

    if (count > 1) {
      const parts = location.pathname.split("/").filter(Boolean);

      // 🚫 NEVER auto set place for things-to-do unless city is explicit
      if (parts[0] === "things-to-do") {
        if (parts.length === 2) return;
        if (parts.length === 3) {
          dispatch(setPlace(parts[2].replace(/%20/g, " ")));
        }
        return;
      }

      // ✅ normal modules
      dispatch(setPlace(parts[parts.length - 1].replace(/%20/g, " ")));
    }
  }, [location.pathname]);


  useEffect(() => {
    AOS.init();
    // Refresh AOS whenever location changes
    AOS.refresh();
  }, []);

  //   useEffect(() => {
  //     window.scrollTo(0, 0)
  //   }, []);

  return (
    <>
      <Routes>
        {/* <Route path="/blog/:sub" element={<ValidateRouteByCity Component={SingleBlog} />} /> */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home/:sub" element={<ValidateRouteByCity Component={Hotels} />} />
          <Route path="/hotel" element={<Hotels />} />
          <Route path="/hotel/:sub" element={<ValidateRouteByCity Component={Hotels} />} />
          <Route path="/flight" element={<Flight />} />
          <Route path="/flight/:sub" element={<ValidateRouteByCity Component={Flight} />} />
          <Route path="/car-rental" element={<CarRental />} />
          <Route path="/car-rental/:sub" element={<ValidateRouteByCity Component={CarRental} />} />
          <Route path="/restaurant" element={<Restaurent />} />
          <Route path="/restaurant/:sub" element={<ValidateRouteByCity Component={Restaurent} />} />
          <Route path="/things-to-do" element={<ThingsToDo />} />
          <Route path="/things-to-do/:value/:place?" element={<ThingsToDoRouteDecider />} />
          <Route path="/things-to-do/:category/:sub" element={<ValidateRouteByCity Component={FilterPopularThings} />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/sports/:sub" element={<ValidateRouteByCity Component={Sports} />} />
          <Route path="/audio-tour" element={<AudioTour />} />
          <Route path="/audio-tour/:sub" element={<ValidateRouteByCity Component={AudioTour} />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/deals/:sub" element={<ValidateRouteByCity Component={NewDeals} />} />
          <Route path="/blog" element={<BlogMain />} />
          <Route path="/blog/:sub" element={<ValidateRouteByCity Component={BlogMain} />} />
          <Route path="/single-blog/:sub" element={<ValidateRouteByCity Component={SingleBlog} />} />
          <Route path="/travelpreferences" element={<MainTravelPreferences />} />
          <Route path="/travelpreferences/:sub" element={<MainTravelPreferences />} />
          <Route path="/experiences/:city" element={<ValidateRouteByCity Component={LeadPage} />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
        <Route path="/experiences" element={<ErrorPage />} />
      </Routes>
    </>
  )
}
export default CreateRoutes;
